export default {
    left: {
        detection: "點擊進行設備檢測",
        group: "我的分組:",
        location: "日程地點:",
        description: "日程說明:",
        scoreChart: "評分表:",
        scoreChartDescription: "評分表說明:",
    },
    logout: "登出",
    right: {
        title: "任務清單",
        searchPlaceholder: "名稱",
    },
    interviewStatus: {
        login: "已登入",
        online: "線上",
        offline: "離線",
    },
    score: "得分",
    average: "平均",
    class: "等級",
    nodata: "暫無任務",
    401: "登入過期,請重新登入",
    status: {
        waiting: "未開始",
        interviewing: "進行中",
        complete: "已結束",
        default: "出錯了",
    },
    signOut: {
        msg: "確定退出面試評分系統？",
        cancel: "取消退出",
    },
};
